export const styles = {
  container: 'w-full h-full relative',
  header: 'relative z-[90]',
  body: 'mobile:px-2 tablet-lg:px-5 py-3 overflow-auto absolute pt-[3.5rem] h-[calc(100%-4.5rem)] z-20',
  'alt-body': 'overflow-auto absolute pt-[3.5rem] h-[calc(100%-4.5rem)] z-20',
  'alt-2-body':
    'mobile:px-3 tablet-lg:px-5 overflow-auto absolute pt-[3rem] h-full z-20',
  footer:
    'mobile:bg-[#08080D] tablet-lg:bg-[#171718] absolute bottom-0 px-3 pb-3',
};
